import React, { useState } from "react";
import { ProductInterface } from "../../interfaces/product/product.interface";
import { DoubleClickButton } from "./buttons/DobuleClick";

interface ConsultantInfoProps {
    product: ProductInterface;
}

export const ConsultantInfo: React.FC<ConsultantInfoProps> = ({ product }) => {
    const [isShow, setIsShow] = useState(false);
    const [type, setType] = useState('');
    const [disabled, setDisabled] = useState(false);

    const sendErrorMessage = () => {
        setDisabled(true);
        if(type.length > 0) {
            fetch('index.php?route=product/product/setError', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: product.id, type })
            })
                .then(response => response.json())
                .then(r => alert(r.message))
                .catch(err => alert(`Error ${ err }`))
                .finally(() => setDisabled(false))
        } else {
            alert('Selectează o deficiență !');
        }
    }

    return (
        <div>
            <DoubleClickButton text="CI" onDoubleClick={ () => setIsShow( !isShow ) } />
            <div className={ `${ !isShow && 'hidden' }` }>
                <table className="table-auto w-full border-collapse border border-red-300">
                    <tbody>
                    <tr>
                        <th className="border border-red-300 p-2">FURNIZOR</th>
                        <td className="border border-red-300 p-2">{ product.consultantInfo.vendor || '' }</td>
                    </tr>
                    <tr>
                        <th className="border border-red-300 p-2">Stock</th>
                        <td className="border border-red-300 p-2">{ product.stockStatusId } - { product.consultantInfo.stockStatusName }</td>
                    </tr>
                    <tr>
                        <th className="border border-red-300 p-2">Quantity</th>
                        <td className="border border-red-300 p-2">{ product.consultantInfo.quantity }</td>
                    </tr>
                    <tr>
                        <th className="border border-red-300 p-2">PRET ACHIZITIE</th>
                        <td className="border border-red-300 p-2">{ product.consultantInfo.priceaq || '' }</td>
                    </tr>
                    <tr>
                        <th className="border border-red-300 p-2">PROFIT</th>
                        <td className="border border-red-300 p-2">
                            { product.consultantInfo.profit_lei || '' }; { product.consultantInfo.profit_percent }
                        </td>
                    </tr>
                    <tr>
                        <th className="border border-red-300 p-2">MODEL</th>
                        <td className="border border-red-300 p-2">{ product.consultantInfo.model }</td>
                    </tr>
                    <tr>
                        <th className="border border-red-300 p-2">URL VENDOR</th>
                        <td className="border border-red-300 p-2">{ product.consultantInfo.urlVendor &&
                            <a target="_blank" href={ product.consultantInfo.urlVendor }>URL Vendor</a> }</td>
                    </tr>
                    <tr>
                        <th className="border border-red-300 p-2">RAPORTEAZĂ</th>
                        <td className="border border-red-300 p-2">
                            <select name="error" id="error" onChange={ (e) => setType(e.target.value) } value={ type }
                                    className="w-full p-2 border border-red-300 block">
                                <option value="">Selectează o deficiență</option>
                                { product.consultantInfo.errors.map((err, i) => (
                                    <option key={ i } value={ err }>{ err }</option>
                                )) }
                            </select>
                            <div className="mt-2">
                                <button disabled={ disabled } onClick={ sendErrorMessage }
                                        className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50">
                                    Trimite
                                </button>
                            </div>
                        </td>
                    </tr>
                    { product.consultantInfo.fetcherLogs &&
                        <tr>
                            <th className="border border-red-300 p-2">LOGS FETCHER</th>
                            <td dangerouslySetInnerHTML={{ __html: product.consultantInfo.fetcherLogs }}></td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        </div>
    )
}